module.exports = __webpack_public_path__ + "static/media/NYT.ab2922d1.png";